import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;

const Heading = tw.h1`font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-gray-900 leading-tight`;
const HeadingRow = tw.div`flex flex-col items-center text-center`;
const Text = tw.div`mt-8 text-base text-gray-600 max-w-3xl mx-auto`;

const FounderGrid = tw.div`grid grid-cols-1 md:grid-cols-2 gap-12 mt-12`;
const FounderCard = tw.div`bg-white rounded-lg shadow-lg overflow-hidden`;
const FounderImage = tw.img`w-full h-96 object-cover`;
const FounderContent = tw.div`p-8`;
const FounderName = tw.h3`text-2xl font-semibold text-gray-900 mb-2`;
const FounderRole = tw.p`text-primary-500 font-medium mb-4`;
const FounderBio = tw.p`text-gray-600 mb-6`;
const FounderQuote = tw.blockquote`italic text-gray-600 border-l-4 border-primary-500 pl-4 mb-6`;

const VisionSection = tw.div`mt-16`;
const VisionCard = tw.div`bg-white rounded-lg shadow-lg p-8`;
const VisionTitle = tw.h3`text-xl font-semibold text-gray-900 mb-4`;
const VisionText = tw.p`text-gray-600 mb-4`;
const VisionList = tw.ul`space-y-2`;
const VisionItem = tw.li`flex items-center text-gray-600`;

export default () => {
  const founders = [
    {
      name: "Assohoun Eddy",
      role: "CEO & Co-fondateur",
      bio: "Ingenieur et tech entrepreneur en Afrique, Eddy a fondé Tanga pour offrir aux entreprises une solution moderne, sécurisée et efficace de gestion des visiteurs. Sa vision : transformer l'accueil dans les locaux grâce à la technologie.",
      quote: "Notre mission est de rendre chaque visite plus sûre, plus rapide et plus agréable, tout en garantissant la traçabilité et la conformité.",
      image: ""
    },
    {
      name: "Paul Niango",
      role: "CTO & Co-fondateur",
      bio: "Expert en systèmes connectés et en solutions digitales, Paul conçoit des solutions robustes pour digitaliser et sécuriser l'expérience visiteur. Il croit en un accueil intelligent, fluide et respectueux de la vie privée.",
      quote: "La technologie doit simplifier l'accueil tout en renforçant la sécurité et la confidentialité des données.",
      image: ""
    }
  ];

  const vision = {
    title: "Notre Vision",
    description: "Nous croyons en un avenir où chaque entreprise peut accueillir ses visiteurs en toute sécurité, avec rapidité et transparence. Tanga place la sécurité, la traçabilité et l'expérience utilisateur au cœur de la gestion des visiteurs.",
    points: [
      "Sécuriser l'accès aux sites et bâtiments",
      "Digitaliser et simplifier le check-in",
      "Garantir la traçabilité des entrées et sorties",
      "Respecter la confidentialité et la conformité RGPD",
      "Offrir une expérience d'accueil moderne et fluide"
    ]
  };

  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>Nos Fondateurs</Heading>
          </HeadingRow>
          <Text>
            <p className="text-center mb-8">
              Découvrez les visionnaires derrière Tanga et leur engagement pour transformer l'Afrique.
            </p>
          </Text>

          <FounderGrid>
            {founders.map((founder, index) => (
              <FounderCard key={index}>
                <FounderImage src={founder.image} alt={founder.name} />
                <FounderContent>
                  <FounderName>{founder.name}</FounderName>
                  <FounderRole>{founder.role}</FounderRole>
                  <FounderBio>{founder.bio}</FounderBio>
                  <FounderQuote>{founder.quote}</FounderQuote>
                </FounderContent>
              </FounderCard>
            ))}
          </FounderGrid>

          <VisionSection>
            <VisionCard>
              <VisionTitle>{vision.title}</VisionTitle>
              <VisionText>{vision.description}</VisionText>
              <VisionList>
                {vision.points.map((point, index) => (
                  <VisionItem key={index}>
                    <span className="mr-2">•</span>
                    {point}
                  </VisionItem>
                ))}
              </VisionList>
            </VisionCard>
          </VisionSection>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 